import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

const STEPS = [
  { num: "01", title: "Let's Talk", copy: "Tell us about your vision, lifestyle, land and requirements." },
  { num: "02", title: "Design", copy: "Develop a concept tailored to you and your site." },
  { num: "03", title: "Plans & Approvals", copy: "Prepare drawings and work through the required permissions." },
  { num: "04", title: "Build", copy: "Our custom building team brings the design to life." },
  { num: "05", title: "Handover", copy: "Complete your new home and hand it over to you." },
];

export default function Process() {
  return (
    <section id="process" className="bg-sand py-24 sm:py-32" data-testid="process-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <p className="eyebrow text-arc mb-6">Our Process</p>
        </Reveal>
        <MaskedLines
          className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
          lines={[<>Your Journey From</>, <><span className="italic text-gradient">Dream</span> to <span className="italic text-gradient">Home.</span></>]}
        />

        <div className="mt-16 relative max-w-3xl">
          <span className="absolute left-[27px] sm:left-[31px] top-2 bottom-2 w-px bg-line" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.07}>
              <div className="relative flex gap-6 sm:gap-9 pb-12 last:pb-0 group" data-testid={`process-step-${s.num}`}>
                <div className="relative z-10 flex-shrink-0 w-[56px] sm:w-[64px] h-[56px] sm:h-[64px] rounded-full bg-cream border border-line flex items-center justify-center group-hover:border-arc group-hover:bg-ink transition-all duration-500">
                  <span className="font-mono text-xs text-arc group-hover:text-sky transition-colors duration-500">{s.num}</span>
                </div>
                <div className="pt-2.5">
                  <h3 className="font-serif text-2xl sm:text-3xl font-medium text-charcoal">{s.title}</h3>
                  <p className="mt-2 text-sm sm:text-base leading-relaxed text-mist">{s.copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-14">
          <a
            href="#contact"
            data-testid="process-cta-start-journey"
            className="group inline-flex items-center justify-center gap-3 bg-arc text-cream font-semibold text-[15px] px-8 py-4 rounded-full hover:bg-arc-dark hover:shadow-xl hover:shadow-arc/25 transition-all duration-300"
          >
            Start Your Journey
            <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
